import { AdvancedMarker } from '@vis.gl/react-google-maps';
import React from 'react';
import MapCluster from '../MapCluster';
import { IOrder } from '@src/pages/Deliveries/context/orders';
import OrderMapMarker from '../MapMarkers/OrderMapMarker';
import dayjs from 'dayjs';
import { Statuses } from '@src/pages/DeliveryDashboard/models/model-constants';
import { useDashboardUIStore } from '@src/pages/DeliveryDashboard/store/dashboardUIStore';
import useDashboardStore from '@src/pages/DeliveryDashboard/hooks/use-dashboard-store';
interface componentProps {
  clusterData: Array<any>;
  supercluster?: any;
  onClusterClick: (cluster: any) => void;
  onOrderMapMarkerClick: (order: IOrder) => void;
  zoom?: number;
}
const ClusterRenderer = ({
  clusterData,
  supercluster,
  onClusterClick,
  onOrderMapMarkerClick,
  zoom,
}: componentProps) => {
  const { activeOrderHash } = useDashboardUIStore();
  const { serverTime } = useDashboardStore();
  useDashboardStore();
  const getClusterUniqueId = () => {
    return `cluster-${new Date().getTime()}-${(Math.random() * 9999999).toFixed(0)}`;
  };
  const isOrderLate = (compareTime: any, dueTime: any) => {
    if (!compareTime || !dueTime || typeof dueTime === 'boolean') return false;
    const dueDate = dayjs(dueTime);
    const serverDate = dayjs(compareTime as any);
    return serverDate.isAfter(dueDate);
  };

  const renderClusters = () => (
    <>
      {clusterData.map((cluster, index) => {
        if (cluster.properties.cluster) {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const childrenData = supercluster?.getLeaves(cluster.id, 1000) || [];
          return (
            <AdvancedMarker
              className={'cluster-element'}
              key={getClusterUniqueId()}
              position={{ lat: latitude, lng: longitude }}
            >
              <MapCluster
                onClick={() => {
                  onClusterClick(cluster);
                }}
                childrenData={childrenData}
              />
            </AdvancedMarker>
          );
        } else {
          const orderData = cluster.properties.orderData as IOrder;
          if (!orderData) {
            return null;
          }
          return (
            <OrderMapMarker
              key={index}
              dueTime={
                orderData.expectedDeliveryTime && orderData.status !== Statuses.Delivered
                  ? dayjs(orderData.expectedDeliveryTime).format('HH:mm')
                  : false
              }
              updateDate={orderData.updateDate}
              orderStatus={orderData.status}
              customerInformation={orderData.customer.lastName}
              showCard={orderData.hash === activeOrderHash}
              position={{ lat: orderData.location.latitude, lng: orderData.location.longitude }}
              onClick={() => onOrderMapMarkerClick(orderData)}
              isLateOrder={isOrderLate(serverTime, orderData.expectedDeliveryTime)}
            />
          );
        }
      })}
    </>
  );

  return <>{renderClusters()}</>;
};
export default React.memo(ClusterRenderer, (prevProps, nextProps) => {
  return (
    prevProps.zoom === nextProps.zoom &&
    prevProps.clusterData.length === nextProps.clusterData.length &&
    prevProps.clusterData === nextProps.clusterData
  );
});
